export default {
    state: {
        appId: localStorage.getItem("appId")
    },
    getters: {
        appId: state => state.appId
    },
    mutations: {
        updateAppId (state, appId) {
            state.appId = appId;
            if (appId) {
                localStorage.setItem("appId", appId);
            } else {
                localStorage.removeItem("appId");
            }

        }
    },
    actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js